import React, { useEffect, useRef } from 'react';
import {
  getUserProfile,
  createOrUpdateUserRecordCollection,
  updateUserRecordUsingJsonPatch,
  getUserRecord,
  deleteUserRecord,
  retrieveAllRecordCollection,
  deleteAllRecordCollection,
  embeddedContentVideo,
  getUserProfileV2,
} from './../../../requests/learningGame';
import { useNavigate } from 'react-router-dom';

export const LearningGame: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) {
      return;
    }

    iframe.onload = () => {
      const childWindow = iframe.contentWindow;
      if (!childWindow) {
        return;
      }

      (childWindow as any).platform = {
        init: async (version: string) => {
          return '1.0.0';
        },
        send: async (requestName: string, requestData: any) => {
          switch (requestName) {
            case 'v1/getUserProfile':
              return getUserProfile();
            case 'v2/userProfile/get':
              return getUserProfileV2();
            case 'v1/record/put':
              return createOrUpdateUserRecordCollection(requestData);
            case 'v1/record/patch':
              return updateUserRecordUsingJsonPatch(requestData);
            case 'v1/record/get':
              return getUserRecord(requestData);
            case 'v1/record/delete':
              return deleteUserRecord(requestData);
            case 'v1/collection/get':
              return retrieveAllRecordCollection(requestData);
            case 'v1/collection/delete':
              return deleteAllRecordCollection(requestData);
            case 'v1/embedded-content/open':
              return embeddedContentVideo(requestData);
            case 'v1/exit':
              navigate('/learning');
              return {};
            default:
              throw new Error(`Unknown request: ${requestName}`);
          }
        },
      };
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={Env.LEARNING_GAME_URL}
      allowFullScreen={true}
      title="Game"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '9999',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        display: 'block',
        margin: '0',
        padding: '0',
        boxSizing: 'border-box',
        minWidth: '100%',
        minHeight: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        transition: 'all 0.3s ease-in-out',
        transform: 'scale(1)',
        transformOrigin: 'top left',
        willChange: 'transform',
      }}
    />
  );
};
